@if (basket()?.lineItems) {
<div class="cart-summary">
  @for (pli of basket().lineItems; track pli; let i = $index) {
  <div class="row cart-summary-checkout">
    @if (isItemVisible(i)) {
    <!-- product name and price -->
    <div class="col-8">
      <ish-product-name ishProductContext [sku]="pli.productSKU" />
    </div>
    <div class="col-4 text-right pt-1">{{ pli.totals.total | ishPrice }}</div>
    <!-- quantity and undiscounted price -->
    <div class="col-8 cart-pli-data">
      <span> {{ 'checkout.pli.qty.label' | translate }} {{ pli.quantity.value }} </span>
    </div>
    <div class="col-4 text-right">
      @if (pli.totals.valueRebatesTotal) {
      <div class="old-price">
        <span class="price-value">{{ pli.totals.undiscountedTotal | ishPrice }}</span>
      </div>
      } @if (pli.isFreeGift) {
      <div class="list-item-promo">{{ 'checkout.pli.freegift.text' | translate }}</div>
      }
    </div>
    <!-- promotions -->
    @if (pli.valueRebates?.length) {
    <div class="col-12">
      @for (rebate of pli.valueRebates; track rebate) {
      <ish-basket-promotion [rebate]="rebate" />
      }
    </div>
    }
    <!-- warranty -->
    @if (pli.warranty) {
    <div class="col-8">{{ pli.warranty.sku }}</div>
    <div class="col-4 text-right">{{ pli.warranty.price | ishPrice }}</div>
    } }
  </div>
  }
  <!-- 'Show All' and 'Hide All' links -->
  @if (isShowAllLinkVisible()) {
  <button type="button" class="btn btn-link btn-content-toggle cart-items-collapse-link" (click)="toggleCollapse()">
    {{ 'checkout.show_all.link' | translate : { '0': basket().lineItems.length } }}&nbsp;
    <fa-icon [icon]="['fas', 'angle-right']" class="float-right" />
  </button>
  } @if (isHideLinkVisible()) {
  <button type="button" class="btn btn-link btn-content-toggle cart-items-collapse-link" (click)="toggleCollapse()">
    {{ 'checkout.hide_all.link' | translate }}
    <fa-icon [icon]="['fas', 'angle-up']" class="float-right" />
  </button>
  }
</div>
}
